// removed by extract-text-webpack-plugin
module.exports = {"Blog":"NewHadith__Blog__36V6W","textArea":"NewHadith__textArea__1cyr3","editordiv":"NewHadith__editordiv__2AId8","br_for_mobile":"NewHadith__br_for_mobile__1y8IQ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/NewHadith/NewHadith.css
// module id = 479
// module chunks = 3